import { InspectionPlanTaskStatus } from 'app/viewmodels/analysis/inspection-plan-status.enum';
import { CONFIG } from '../../core/config';
import { DeferralStatusType } from '../../shared/mitigation-plan/deferral-status-type';
import { BusinessEntity } from '../business-entity';
import { InspectionPlanTaskMitigationColumn } from './inspection-plan-task-mitigation-column';
import { MitigationPlanTaskSource } from './inspection-plan-task-source';
import { LastInspectionDateSource } from './last-inspection-date-source';
import { MitigationPlanFrequencySource } from './mitigation-plan-frequency-source';

interface InspectionPlanTaskStatusValues {
  id: InspectionPlanTaskStatus;
  name: string;
}


export class Recommendation extends BusinessEntity {
  public recommendationId: string;
  public orgTreeNodeId: string;
  public orgTreeNodeModelRunId: string;
  public inspectionPlanId: string;
  public inspectionPlanTaskId: string;
  public inspectionPlanTaskStatus: InspectionPlanTaskStatusValues;
  public mitigationType: string;
  public rowIndex: number;
  public taskReference: string;
  public taskName: string;
  public taskFrequency: number;
  public taskFrequencyDetails: string;
  public frequencySource: MitigationPlanFrequencySource;
  public taskInterval: string;
  public taskExtent: string;
  public dueDate: string;
  public revisedDueDate: string;
  public deferralStatus: DeferralStatusType;

  public isStaticDueDate: boolean;
  public originalDueDate: string;
  public included: boolean;
  public sourceType: MitigationPlanTaskSource;
  public canToggle: boolean;
  public installationDate: Date;
  public lastInspectionId: string;
  public lastInspectionDate: string;
  public lastModifiedBy: string;
  public lastInspectionDateSource: LastInspectionDateSource;

  public flagtaskInterval: boolean;
  public flagtaskFrequency: boolean;
  public flagtaskExtent: boolean;
  public flagtaskName: boolean;
  public flagmitigationType: boolean;
  public flagRow: boolean;

  public mitigationSource: boolean;
  public overrideFrequency: boolean;
  public lastInspectionDateOverriden: boolean;

  public sendToErp: boolean;
  public erpMaintenancePlanNumber: string;
  public erpNotificationNumber: string;
  public erpNotificationSystemStatus: string;
  public erpWorkOrderNumber: string;
  public erpWorkOrderSystemStatus: string;
  public erpNotificationUserStatus: string;
  public erpPackageNumber: string;
  public erpMaintenanceItemNumber: string;
  public erpWorkOrderUserStatus: string;
  public erpAvailability: string;
  public erpMaintenanceActivityType: string;
  public erpPlannerGroup: string;
  public erpWorkCenter: string;

  // used in recommendation
  public mitigationRowId: string;

  public displayedMitigationColumns: string;
  public mitigationColumns: InspectionPlanTaskMitigationColumn[] = [];

  public masterInspectionMethodId: string;
  public masterInspectionMethodName: string;
  public discriminator: string;
  constructor() {
    super();
    this.friendlyTypeNameSingular = 'Recommendation';
    this.apiRoute = CONFIG.apiRoutes.recommendations;
  }

  public json() {
    return this;
  }

  public loadFromJson(data) {
    super.loadFromJson(data);
    this.recommendationId = data.recommendationId;
    this.orgTreeNodeId = data.orgTreeNodeId;
    this.orgTreeNodeModelRunId = data.orgTreeNodeModelRunId;
    this.inspectionPlanId = data.inspectionPlanId;
    this.inspectionPlanTaskId = data.inspectionPlanTaskId;
    this.inspectionPlanTaskStatus = data.inspectionPlanTaskStatus;
    this.mitigationType = data.mitigationType;
    this.rowIndex = data.rowIndex;
    this.taskReference = data.taskReference;
    this.taskName = data.taskName;
    this.taskFrequency = data.taskFrequency == null ? data.taskFrequency : +(+data.taskFrequency.toFixed(2));
    this.frequencySource = data.frequencySource;
    this.taskInterval = data.taskInterval;
    this.taskFrequencyDetails = this.taskFrequency + ' ' + this.taskInterval;
    this.taskExtent = data.taskExtent;
    this.dueDate = data.dueDate;
    this.revisedDueDate = data.revisedDueDate;
    this.deferralStatus = data.deferralStatus;
    this.isStaticDueDate = data.isStaticDueDate;
    this.originalDueDate = data.originalDueDate;
    this.sourceType = data.sourceType;
    this.installationDate = data.installationDate;
    this.lastInspectionId = data.lastInspectionId;
    this.lastInspectionDate = data.lastInspectionDate;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastInspectionDateSource = data.lastInspectionDateSource;
    this.mitigationSource = data.mitigationSource;
    this.overrideFrequency = data.overrideFrequency;
    this.lastInspectionDateOverriden = data.lastInspectionDateOverriden;

    this.sendToErp = data.sendToErp;
    this.erpMaintenancePlanNumber = data.erpMaintenancePlanNumber;
    this.erpNotificationNumber = data.erpNotificationNumber;
    this.erpNotificationSystemStatus = data.erpNotificationSystemStatus;
    this.erpWorkOrderNumber = data.erpWorkOrderNumber;
    this.erpWorkOrderSystemStatus = data.erpWorkOrderSystemStatus;
    this.erpNotificationUserStatus = data.erpNotificationUserStatus;
    this.erpAvailability = data.erpAvailability;
    this.erpMaintenanceActivityType = data.erpMaintenanceActivityType;
    this.erpPlannerGroup = data.erpPlannerGroup;
    this.erpWorkCenter = data.erpWorkCenter;

    this.mitigationRowId = data.mitigationRowId;
    this.erpPackageNumber = data.erpPackageNumber;
    this.erpMaintenanceItemNumber = data.erpMaintenanceItemNumber;
    this.erpWorkOrderUserStatus = data.erpWorkOrderUserStatus;
    this.displayedMitigationColumns = data.displayedMitigationColumns;
    this.mitigationColumns = [];
    if (data.mitigationColumns) {
      for (const mitigationColumn of data.mitigationColumns) {
        const newMitigationColumn = new InspectionPlanTaskMitigationColumn();
        newMitigationColumn.loadFromJson(mitigationColumn);
        this.mitigationColumns.push(newMitigationColumn);
      }
    }

    this.masterInspectionMethodId = data.masterInspectionMethodId;
    this.masterInspectionMethodName = data.masterInspectionMethodName;
    this.discriminator = data.discriminator;

    this.canEdit = this.inspectionPlanTaskStatus?.id === InspectionPlanTaskStatus.Active || this.inspectionPlanTaskStatus?.id === InspectionPlanTaskStatus.Recommended;
  }
}
